<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import errorIcon from "@core/assets/icons/error.svg?raw";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const { ...rest }: HTMLTextareaAttributes = $props();

	let validityMessage = $state("");
	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void {
		if (currentTarget.validity.valid) {
			currentTarget.setCustomValidity("");
		}
		validityMessage = currentTarget.validationMessage;
	}
</script>

<div class="relative">
	<textarea
		use:updateTextareaHeight
		{...rest}
		class={[
			"border border-fcrlightgray-300 rounded-3xl bg-fcrlightgray-200 p-6 resize-none",
			"text-base text-fcrdarkgray placeholder:text-fcrgray w-full !outline-none",
			"focus:border-fcrdarkgray focus:border-2",
			validityMessage && "[&:user-invalid]:border-fcrerror [&:user-invalid]:border-2",
			"peer",
			rest.class,
		]}
		oninvalid={(event: Event & { currentTarget: EventTarget & HTMLTextAreaElement }): void => {
			event.preventDefault();
			validate(event);
		}}
	></textarea>
	<div class="absolute inset-x-0 top-6 hidden peer-[:user-invalid]:flex items-center justify-end pointer-events-none">
		<div class="pr-6">
			<Icon icon={errorIcon} class="size-5.5 text-fcrerror" />
		</div>
	</div>
	<div class="justify-end text-sm text-fcrerror pr-6 pt-1 hidden peer-[:user-invalid]:flex">
		<Formatted text={validityMessage} />
	</div>
</div>
